import { render, staticRenderFns } from "./TagApp.vue?vue&type=template&id=e236655a&scoped=true&"
import script from "./TagApp.vue?vue&type=script&lang=js&"
export * from "./TagApp.vue?vue&type=script&lang=js&"
import style0 from "./TagApp.vue?vue&type=style&index=0&id=e236655a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e236655a",
  null
  
)

export default component.exports